import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import ThreeOptions from '../ThreeOptions'
import StepCounter from '../StepCounter'

import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import gif8 from './assets/09_chart 2.gif'
import jpg8 from './assets/static/09_chart-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q8() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif8" src={settings.isAnimationPause ? jpg8 : gif8} />
            </div>
            <Headling text={translate('Size Matters')} />
            <Subtitle text={translate('How big is my investment portfolio?')} />
            <ThreeOptions option1={translate('Up to NIS 50,000')}
                option2={translate('NIS 50,000-150,000')}
                option3={translate('Over NIS 150,000')}
                onOption1Press={() => {
                    setNewAnswer({ 8: 1 })
                    history.push('/Q/9')
                    ReactPixel.trackCustom('less_50', '');
                }}
                onOption2Press={() => {
                    setNewAnswer({ 8: 2 })
                    history.push('/Q/9')
                    ReactPixel.trackCustom('50_to_150', '');
                }}
                onOption3Press={() => {
                    setNewAnswer({ 8: 3 })
                    history.push('/Q/9')
                    ReactPixel.trackCustom('more_150', '');
                }}

            />
            <StepCounter />

        </>
    )
}



export default Q8

